module.exports = __webpack_public_path__ + "media/images/white_icon_48x48-d9855d98.png";